module.exports = __webpack_public_path__ + "img/whats-ss-img2.d5daf815.png";